<script lang="ts" setup>
import {route} from "@/common/utils/ziggy"
import AdminMain from "~components/admin/AdminMain.vue"
import AdminNav from "~components/admin/AdminNav.vue"
import WithServices from "~components/services/WithServices.vue"
import SentryContext from "~components/util/SentryContext.vue"

defineProps<{
  sentryContext: unknown
}>()
</script>

<template>
  <div class="admin-page">
    <SentryContext :context="sentryContext"/>

    <WithServices :discovery-url="route('service.objects._services.browse')">
      <AdminNav/>

      <AdminMain>
        <slot/>
      </AdminMain>

      <AdminFooter/>
    </WithServices>
  </div>
</template>
